import { SET_LIVE_FEEDINGS, SET_LIVE_STREAMS, SET_LIVE_TALKS } from './types';

const initialState = {
  liveTalks: [],
  liveFeedings: [],
  liveStreams: [],
};

export default (state = initialState, action = {}) => {
  const { type, payload = {} } = action;

  switch (type) {
    case SET_LIVE_TALKS: {
      const { list } = payload;
      return {
        ...state,
        liveTalks: list,
      };
    }

    case SET_LIVE_FEEDINGS: {
      const { list } = payload;
      return {
        ...state,
        liveFeedings: list,
      };
    }

    case SET_LIVE_STREAMS: {
      return {
        ...state,
        ...payload,
      };
    }

    default: {
      return state;
    }
  }
};
